import PremierGolfLeaderboardBanner from './premier-golf-leaderboard-banner'

export default PremierGolfLeaderboardBanner
